import { NordEvent } from '../common/events.js'

/**
 * Dispatched by `nord-calendar` in `range` mode when a complete range has been
 * selected (the user has clicked a start day and then an end day). Carries the
 * inclusive `start` and `end` dates, normalised so `start <= end`.
 */
export class DateRangeSelectEvent extends NordEvent {
  constructor(
    name: string,
    public start: Date,
    public end: Date,
  ) {
    super(name)
  }

  /** Convenience accessor mirroring `CustomEvent.detail`. */
  get detail() {
    return { start: this.start, end: this.end }
  }
}
